// extracted by mini-css-extract-plugin
export var divider = "_tv-0";